import { apiCall } from "./authServices";

export const postExamCreation = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/exams/module-exam",
      method: "POST",
      payload,
    });
    return response;
  } catch (error) {
    console.error("Error :", error);
    throw error;
  }
};

export const getModuleExam = async (id) => {
  try {
    const response = await apiCall({
      endpoint: `api/exams/module-exam/${id}`,
      method: "GET",
    });
    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const getUserExam = async (moduleId) => {
  try {
    const response = await apiCall({
      endpoint: `api/exams/module-exam-details/${moduleId}`,
      method: "GET",
    });
    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};
export const getUserQuestion = async (examId) => {
  try {
    const response = await apiCall({
      endpoint: `api/exams/module-exam-questions/${examId}`,
      method: "GET",
    });
    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};

export const postExamQuestion = async (payload) => {
  try {
    const response = await apiCall({
      endpoint: "api/exams/exam-result",
      method: "POST",
      payload,
    });
    return response;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};